import moment from 'moment';
export default {
  install: (Vue, options) => {
    Vue.prototype.$helpers = {
      apiConnect(url, json) {
        // var feedback = {
        //   success: false,
        //   status: errorTags.request.failed
        // };
        // return new Promise((resolve, reject) => {
        //   Vue.http.post(url, json).then(
        //     successResponse => {
        //       if (successResponse) {
        //         feedback.success = typeof successResponse.data.status == "string" ? successResponse.data.status == "1" : successResponse.data.status == 1;
        //         feedback.status = successresponse.status;
        //         if (feedback.success == true) {
        //           feedback.data= successResponse.data;
        //           resolve(feedback);
        //         }
        //         else {
        //           resolve(feedback)
        //         }
        //       }
        //       else {
        //         resolve(feedback); // Response is empty...
        //       }
        //     },
        //     errorResponse => {
        //       feedback.error = errorResponse;
        //       reject(feedback);
        //     }
        //   );
        // }).catch(e => {
        //   feedback.error = e;
        //   reject(feedback);
        // });
      },
      showDialog(title, message, variant, target) {
        target.$swal({
          title: title,
          text: message,
          type: variant,
        }).then((result)=>{});
      },
      errorHandling(title, message, variant, target) {
        switch(message) {
          case "session_expired":
            target.$swal({
              title: title,
              text: target.$tc('message.list.'+message),
              type: variant
            }).then(result => {
              target.$store
                .dispatch("user/logout")
                .then(() => this.$router.push("/"))
                .catch(err => console.log(err));
            });
            break;
          default:
            break;
          }
      },
      getDateTime(datetime){
        if(datetime != null && datetime != undefined && datetime != ""){
          var returnDateTime = options.$moment(datetime).format('YYYY-MM-DD HH:mm:ss');
          return returnDateTime;
        }else{
          return "-";
        }
      },
      redirect(page) {
        return options.$router.push("/" + page).catch(error =>{});
      },
      // onlyNumber($event) {
      //   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      //   if ((keyCode < 48 || keyCode > 57) && [43, 45, 46, 101, 187, 188, 189, 190].includes(keyCode)) { // prevent: "e", "=", ",", "-", "."
      //     $event.preventDefault();
      //   }
      // },
      onlyNumber($event) {
        let keyCode = ($event.which) ? $event.which : $event.keyCode;
        if (keyCode > 31 && (keyCode < 48 || keyCode > 57)){
          $event.preventDefault();
        }
      },
      floatAnimation(){
        // window.requestAnimationFrame = (function() {
        //   return window.requestAnimationFrame ||
        //       window.webkitRequestAnimationFrame ||
        //       window.mozRequestAnimationFrame ||
        //       function(callback) {
        //           window.setTimeout(callback, 1000 / 60);
        //       };
        // })();
  
        var $parent = $("#parent"),
            $elements = $('.winning-game-thumb', $parent),
            vertSpeed = 2,
            horiSpeed = 2;
    
        var height = $parent.height(),
            width = $parent.width();
            $parent.css("position", "relative").css("overflow", "hidden");
    
        // store all the data for animation
        var items = [];
        for (var i = 0; i < $elements.length; i++) {
            var $element = $($elements[i]),
                elementWidth = $element.width(),
                elementHeight = $element.height();
    
            $element.css("position", "absolute");
    
            var item = {
                element: $element[0],
                elementHeight: elementHeight,
                elementWidth: elementWidth,
                ySpeed: -vertSpeed,
    
                omega: 2 * Math.PI * horiSpeed / (width * 60), //omega= 2Pi*frequency
                random: (Math.random() / 2 + 0.5) * i * 10000, //random time offset
                x: function(time) {
                    return (Math.sin(this.omega * (time + this.random)) + 1) / 2 * (width - elementWidth);
                },
                y: height + (Math.random() + 1) * i * elementHeight,
            }
            items.push(item);
        }
    
        var counter = 0;
        var animationStep = function() { //called 60 times a second
            var time = +new Date(); //little trick, gives unix time in ms
            var check = (counter % 10 === 0);
    
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
    
                var transformString = "translate3d(" + item.x(time) + "px," + item.y + "px,0px)";
                item.element.style.transform = transformString;
                item.element.style.webkitTransform = transformString;
    
                item.y += item.ySpeed;
                if (check && item.y < -item.elementHeight) { //check bounds every 10th iteration
                    item.y = height;
                }
            }
    
            counter %= 10;
            counter++;
            requestAnimationFrame(animationStep);
        }
  
        requestAnimationFrame(animationStep);
      },
      drawChart(data){
        window.chartColors = {
          green: '#348e40',
          greendark:'#314448',
          blue: '#01c7f8',
          bluedark:'#273d6e', 
        };
        // window.randomScalingFactor = function() {
        //     return (Math.random() > 0.2 ? 0.8 : 1.0) * Math.round(Math.random() * 100);
        // };

        //withdrawal count total
        var countTotal_1 = data.count00 + data.count01;
        var countTotal_2 = countTotal_1 + data.count02;
        var countTotal_3 = countTotal_2 + data.count03;
        var countTotal_4 = countTotal_3 + data.count04;
        var countTotal_5 = countTotal_4 + data.count05;
        var countTotal_6 = countTotal_5 + data.count06;
        var countTotal_7 = countTotal_6 + data.count07;
        var countTotal_8 = countTotal_7 + data.count08;
        var countTotal_9 = countTotal_8 + data.count09;
        var countTotal_10 = countTotal_9 + data.count10;
        var countTotal_11 = countTotal_10 + data.count11;
        var countTotal_12 = countTotal_11 + data.count12;
        var countTotal_13 = countTotal_12 + data.count13;
        var countTotal_14 = countTotal_13 + data.count14;
        var countTotal_15 = countTotal_14 + data.count15;
        var countTotal_16 = countTotal_15 + data.count16;
        var countTotal_17 = countTotal_16 + data.count17;
        var countTotal_18 = countTotal_17 + data.count18;
        var countTotal_19 = countTotal_18 + data.count19;
        var countTotal_20 = countTotal_19 + data.count20;
        var countTotal_21 = countTotal_20 + data.count21;
        var countTotal_22 = countTotal_21 + data.count22;
        var countTotal_23 = countTotal_22 + data.count23;
        var countTotal_24 = countTotal_23 + data.count24;

        //withdrawal amount total
        var amountTotal_00 = data.amount00;
        var amountTotal_01 = data.amount00 + data.amount01;
        var amountTotal_02 = amountTotal_01 + data.amount02;
        var amountTotal_03 = amountTotal_02 + data.amount03;
        var amountTotal_04 = amountTotal_03 + data.amount04;
        var amountTotal_05 = amountTotal_04 + data.amount05;
        var amountTotal_06 = amountTotal_05 + data.amount06;
        var amountTotal_07 = amountTotal_06 + data.amount07;
        var amountTotal_08 = amountTotal_07 + data.amount08;
        var amountTotal_09 = amountTotal_08 + data.amount09;
        var amountTotal_10 = amountTotal_09 + data.amount10;
        var amountTotal_11 = amountTotal_10 + data.amount11;
        var amountTotal_12 = amountTotal_11 + data.amount12;
        var amountTotal_13 = amountTotal_12 + data.amount13;
        var amountTotal_14 = amountTotal_13 + data.amount14;
        var amountTotal_15 = amountTotal_14 + data.amount15;
        var amountTotal_16 = amountTotal_15 + data.amount16;
        var amountTotal_17 = amountTotal_16 + data.amount17;
        var amountTotal_18 = amountTotal_17 + data.amount18;
        var amountTotal_19 = amountTotal_18 + data.amount19;
        var amountTotal_20 = amountTotal_19 + data.amount20;
        var amountTotal_21 = amountTotal_20 + data.amount21;
        var amountTotal_22 = amountTotal_21 + data.amount22;
        var amountTotal_23 = amountTotal_22 + data.amount23;
        // var amountTotal_24 = data.amount00 + data.amount01 + data.amount02 + data.amount03 + data.amount04 + data.amount05 + data.amount06 + data.amount07 + data.amount08 + data.amount09 + data.amount10 + data.amount11 + data.amount12 + data.amount13 + data.amount14 + data.amount15 + data.amount16 + data.amount17 + data.amount18 + data.amount19 + data.amount20 + data.amount21 + data.amount22 + data.amount23 + data.amount24;


    
        var config = {
          type: 'line',
          data: {
            labels: ["12:00 am", "1:00 am","2:00 am", "3:00 am","4:00 am", "5:00 am", "6:00 am","7:00 am", "8:00 am", "9:00 am", "10:00 am", "11:00 am","12:00 pm","13:00 pm","14:00 pm","15:00 pm","16:00 pm","17:00 pm","18:00 pm","19:00 pm","20:00 pm","21:00 pm","22:00 pm","23:00 pm","23:59 pm"],
            datasets: [{
              label: "Count",
              backgroundColor: window.chartColors.bluedark,
              borderColor: window.chartColors.blue,
              // data: [49, 50, 59, 60, 65, 68, 71, 75, 79, 81, 85, 89, 92, 95, 100, 105, 108, 112, 125, 135, 140, 145, 158, 160, 163],
              data:[
                0,
                data.count00*10,
                countTotal_1*10,
                countTotal_2*10,
                countTotal_3*10,
                countTotal_4*10,
                countTotal_5*10,
                countTotal_6*10,
                countTotal_7*10,
                countTotal_8*10,
                countTotal_9*10,
                countTotal_10*10,
                countTotal_11*10,
                countTotal_12*10,
                countTotal_13*10,
                countTotal_14*10,
                countTotal_15*10,
                countTotal_16*10,
                countTotal_17*10,
                countTotal_18*10,
                countTotal_19*10,
                countTotal_20*10,
                countTotal_21*10,
                countTotal_22*10,
                countTotal_23*10,
                countTotal_24*10
              ],
              pointRadius:0,
            }, {
              label: "Amount",
              backgroundColor: window.chartColors.greendark,
              borderColor: window.chartColors.green,
              // data: [0, amountTotal_00, amountTotal_01, amountTotal_02, amountTotal_03, amountTotal_04, amountTotal_05, amountTotal_06, amountTotal_07, amountTotal_08, amountTotal_09, amountTotal_10, amountTotal_11, amountTotal_12, amountTotal_13, amountTotal_14, amountTotal_15, amountTotal_16, amountTotal_17, amountTotal_18, amountTotal_19, amountTotal_20, amountTotal_21, amountTotal_22, 203],
              data:[
                0,
                data.amount00,
                amountTotal_01.toFixed(2),
                amountTotal_02.toFixed(2),
                amountTotal_03.toFixed(2),
                amountTotal_04.toFixed(2),
                amountTotal_05.toFixed(2),
                amountTotal_06.toFixed(2),
                amountTotal_07.toFixed(2),
                amountTotal_08.toFixed(2),
                amountTotal_09.toFixed(2),
                amountTotal_10.toFixed(2),
                amountTotal_11.toFixed(2),
                amountTotal_12.toFixed(2),
                amountTotal_13.toFixed(2),
                amountTotal_14.toFixed(2),
                amountTotal_15.toFixed(2),
                amountTotal_16.toFixed(2),
                amountTotal_17.toFixed(2),
                amountTotal_18.toFixed(2),
                amountTotal_19.toFixed(2),
                amountTotal_20.toFixed(2),
                amountTotal_21.toFixed(2),
                amountTotal_22.toFixed(2),
                amountTotal_23.toFixed(2)
              ],
              pointRadius:0,
            }]
          },
          options: {
            elements: {
                line: {
                    tension: 0 // disables bezier curves
                }
            },
            animation:{
              duration: 0
            },
            hover:{
              animationDuration: 0
            },
            responsiveAnimationDuration:0,
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                position: 'top'
            },
            title: {
                position: 'left',
                display: false,
                text:"Withdrawal",
                fontColor: 'white'
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                // enabled: false,
                callbacks: {
                  label: function(tooltipItem, data){
                    var label = data.datasets[tooltipItem.datasetIndex].label;
                    if(tooltipItem.datasetIndex === 0){
                      var value = Number(tooltipItem.value) / 10;
                    }else{
                      var value = tooltipItem.value;
                    }
                    return label + ":" + value;
                  }
                }
            },
            hover: {
                mode: 'nearest',
                intersect: false,
            },
            scales: {
              xAxes: [{
                position: 'bottom',
                gridLines: {
                  borderDash: [2, 2],
                  color: 'rgba(255,255,255,0.2)',
                  // zeroLineColor: '#fff',
                  // zeroLineWidth: 1,
                },
                ticks:{
                  fontColor: "rgba(255,255,255,0.5)",
                  display: true,
                  beginAtZero: true,
                  fontSize: 10,
                }
              }],
              yAxes: [{
                gridLines: {
                  // zeroLineColor: '#fff',
                  color: "rgba(0, 0, 0, 0)",
                },
                ticks:{
                  fontColor: "white",
                  display: false,
                  beginAtZero: true,
                }
              }]               
            }
          }
        };
    
        //Draw chart
        window.onload = function() {
            var ctx = document.getElementById("chart").getContext("2d");
            window.myLine = new Chart(ctx, config);
        };
    
        //Update type of chart 
        $('#updateChart').click(function(e) {
            var chart = window.myLine;
            var types = ['line', 'ine'];
          
            chart.config.type = types[Math.floor(Math.random()*3)];
            chart.destroy();
    
            var ctx = document.getElementById("chart").getContext("2d");
            window.myLine = new Chart(ctx, chart.config);
        });
      },
      hideOnScroll(){
        var didScroll;
        var lastScrollTop = 0;
        var delta = 10;
        var navbarHeight = $('.top').outerHeight();

        $(document).scroll(function(event) {
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(document).scrollTop();

            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            if (st > lastScrollTop && st > navbarHeight) {
                $('.top').css({ "top": "-190px" });
                $('.footer-nav').css({ "bottom": "-100px" });

            } else {
                if (st < lastScrollTop) {
                    $('.top').css({ "top": "0px" });
                    $('.footer-nav').css({ "bottom": "0px" });
                }
            }

            lastScrollTop = st;
        }
      },
      animateNum(){
        (function($) {
          $('.counter-value').countUp();
        })(jQuery);
        
        
        $(document).ready(function(){
            $('.counter-value').waypoint(function(direction) {
                myfunc_meter(this.element, direction); //when using waypoint, this refers to the waypoint object
            },{offset:'100%'});
            function myfunc_meter(target, direction){
                if(direction === "down"){
                    $("#counter .pin").addClass("fast");
              
                    setTimeout(function(){
                    $("#counter .pin").removeClass("fast");
                    $("#counter .pin").removeClass("start");
                }, 1000);
                }
            }
        
            $('.gameplay').waypoint(function(direction) {
                $('#vid-gameplay').trigger('play');
            },{offset:'100%'});
              
        });
      },
      swiper(){
        var swiper = new Swiper('.aboutus-swiper-container', {
            effect: 'cube',
            grabCursor: true,
            loop: true,
            cubeEffect: {
                shadow: false,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
            },
        });
      },
      fmt(v, t = false) {
        if (v == null) return null;
        var r = v.toString();
    
        if (r == "0") {
          return "";
        }
    
        var i = r.indexOf(".");
        if (i <= 0) {
          return r;
        }
    
        var l = 4;
        var da = r.substr(i + 1, 3);
        var d1 = r.substr(i + 1, 1);
        var d2 = r.substr(i + 2, 1);
        var d3 = r.substr(i + 3, 1);
    
        if (d3 == "5") {
          l = 4;
        } else {
          if (t) {
            if (v >= 10) {
              if (da == "000") {
                l = 0;
              } else {
                if (d2 != "0") {
                  l = 3;
                } else {
                  if (d1 != "0") {
                    l = 2;
                  } else {
                    l = 0;
                  }
                }
              }
            }
          }
        }
        var rs = r.substr(0, i + l);
        return rs;
      },
      betDisplay(item, t, lang) {
        var result = "";
        switch (item.bet_type) {
          case "PARLAY":
            result = "";
            break;
          case "HDP":
          case "HDPH":
            result = item.home_away == 1 ? this.getHomeTeam(item, lang) : this.getAwayTeam(item, lang);
            break;
          case "OU":
          case "OUH":
            result = item.home_away == 1 ? t.$t("ui.over") : t.$t("ui.under");
            break;
          case "OE":
          case "OEH":
            result = item.home_away == 1 ? t.$t("ui.odd") : t.$t("ui.even");
            break;
          case "ML":
          case "MLH":
            result = item.home_away == 1 ? t.$t("m.BT_H") : t.$t("m.BT_A");
            break;
          case "1X2":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_FT1");
                break;
              case 2:
                result = t.$t("m.BT_FT2");
                break;
              case 3:
                result = t.$t("m.BT_FTX");
                break;
            }
            break;
          case "1X2H":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_HT1");
                break;
              case 2:
                result = t.$t("m.BT_HT2");
                break;
              case 3:
                result = t.$t("m.BT_HTX");
                break;
            }
            break;
          case "1X2HDP":
          case "1X2HDPH":
            switch (item.home_away) {
              case 1:
                result = t.$t("m.BT_H");
                break;
              case 2:
                result = t.$t("m.BT_A");
                break;
              case 3:
                result = t.$t("m.BT_D");
                break;
            }
            break;
          case "CS":
          case "CSH":
          case "TG":
          case "TGH":
          case "OR":
          case "BS":
            result = item.criteria1;
            break;
          case "HTFT":
          case "HTFTH":
          case "FGLG":
          case "FGLGH":
          case "CL":
          case "HNB":
          case "ANB":
          case "DNB":
          case "TWTN":
            result = t.$t("m.BT_" + item.criteria1);
            break;
          case "DC":
          case "DCH":
            result = t.$t("m.BT_" + item.criteria1 + "_DC");
            break;
        }
    
        return result;
      },
      getHomeTeam(e, lang) {
        var r = e["home_name_" + lang];
        if (r != null && r != "") {
          return r;
        }
        return e.home_team_name;
      },
      getAwayTeam(e, lang) {
        var r = e["away_name_" + lang];
        if (r != null && r != "") {
          return r;
        }
        return e.away_team_name;
      },
      routeCheck(route){
        var list = ["/promotions", "/inbox", "/profile", "/aboutUs", "/tnc", "/faq", "/deposit", "/withdrawal", "/statement", "/referral","/missions","/euro2024","/reset-password","/slot","/live","/fishing"]
        if(list.includes(route)){console.log('hehehe')
          return false
        }else{console.log('11111')
          return true
        }
      },
      footerFilter(route){
        var list = ["/aboutUs", "/tnc", "/faq"]
        if(list.includes(route)){
          return true
        }else{
          return false
        }
      },
      openModal(target){
        $(target).modal("show")
      },
      closeModal(target){
        $(target).modal("hide")
      },
      timingControl(startDateTime, endDateTime){
        const now = moment();
        const start = moment(startDateTime, 'YYYY-MM-DD HH:mm');
        if(endDateTime){
          var end = moment(endDateTime, 'YYYY-MM-DD HH:mm');
        }
        if(now.isSameOrAfter(start)){
          if(endDateTime){
            if(now.isSameOrAfter(end)){
              return false
            }else{
              return true
            }
          }else{
            return true
          }
          
        }else{
          return false
        }
      },
      handleImageError(event, provider) {
        event.src = '/images/fallb/'+provider+'.png'; // Set fallback image
        // switch(provider){
        //   case "EPIC2":
        //     event.src = '/images/fallb/epicwin.png'; // Set fallback image
        //     break;
        //   case "MEGAH5":
        //     event.src = '/images/fallb/megaH5.png'; // Set fallback image
        //     break;
        //   case "EVO":
        //     event.src = '/images/fallb/evo.png'; // Set fallback image
        //     break;
        //   case "PPS":
        //     event.src = '/images/fallb/pragmatic.png'; // Set fallback image
        //     break;
          
        //   default:
        //     event.src = '/images/default.gif'; // Set fallback image
        //     break;
        // }
        
      },
      openChat(){
        LiveChatWidget.call("maximize");
      },
      timingDate(){
        const day = moment().day(); 
        const dayExclude = [1,2]
        if(dayExclude.includes(day)){
          return false
        }else{
          return true
        }
      },
    };
  }
};